import React from 'react';
import { Text } from '@fiverr-private/typography';
import { DATETIME_ELEMENT_STYLES, dateTimeFormat } from '@fiverr-private/localization';
import { Gql } from '@fiverr-private/dynamic_matching';
import { AppI18n } from '../../../i18n';
import { ViewComponentProps } from '..';
import { TimelineContentType } from '.';

export const ViewTimeline = ({ section }: ViewComponentProps) => {
  const { timeline, deliveryDate } = (section?.content || {}) as TimelineContentType;

  const date =
    deliveryDate &&
    dateTimeFormat({
      value: Number(deliveryDate),
      options: {
        day: DATETIME_ELEMENT_STYLES.TWO_DIGIT,
        month: DATETIME_ELEMENT_STYLES.TWO_DIGIT,
        year: DATETIME_ELEMENT_STYLES.NUMERIC,
      },
    });

  const translation = (): React.JSX.Element => {
    switch (timeline) {
      case Gql.DmBriefTimeline.Flexible:
        return <AppI18n k="sections.timeline.flexible" />;
      case Gql.DmBriefTimeline.SoonAsPossible:
        return <AppI18n k="sections.timeline.asap" />;
      case Gql.DmBriefTimeline.Ongoing:
        return <AppI18n k="sections.timeline.ongoing_need" />;
      case Gql.DmBriefTimeline.SpecificDate:
        return (
          <AppI18n
            k="sections.timeline.done_by"
            params={{
              date,
            }}
          />
        );
      default:
        return (
          <>
            (<AppI18n k="sections.mandatory" />)
          </>
        );
    }
  };

  return <Text> {translation()} </Text>;
};
